function solveMath(mathExpression) {
  /* Using the regex ensures, we cant execute malicious code. */
  mathExpression = mathExpression.match(/^[-+*/0-9.\s]+$/).pop()

  // eslint-disable-next-line no-new-func
  return new Function(`return ${mathExpression}`)()
}

export function createChallenge() {
  const operators = ['+', '-']
  const challenge = {
    text: '5 + 10',
    result: 15
  }

  for (let i = 0; i < 10000; i++) {
    const num1 = Math.floor(Math.random() * 10) + 1
    const num2 = Math.floor(Math.random() * 10) + 1
    const operator = operators[Math.floor(Math.random() * operators.length)]

    if (operator === '-' && num1 <= num2) continue
    challenge.text = `${num1} ${operator} ${num2}`
    challenge.result = solveMath(challenge.text)
  }

  return challenge
}
